// extracted by mini-css-extract-plugin
module.exports = {"caption":"sub-menu_caption__96EEL","menuList":"sub-menu_menuList__1tkaG"};